export function vmIsDestroyed(vm) {
  return vm.isUnmounted === true || vm.isDeactivated === true
}
export function vmHasRouter(vm) {
  return vm.appContext.config.globalProperties.$router !== undefined
}
